import React from 'react';
import StyledLink from './styles';
var SkipToContent = function SkipToContent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '#main-content' : _ref$href;
  return /*#__PURE__*/React.createElement(StyledLink, {
    className: "sr-focusable",
    href: href
  }, "Skip to content");
};
SkipToContent.displayName = "SkipToContent";
export default SkipToContent;
//# sourceMappingURL=index.js.map